export default __webpack_public_path__ + "assets/models/050e8a5d89451eb668d6eda193884ab5.glb";